(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const compactCollectionCards = () => {
    if (!window.matchMedia('(min-width: 1200px)').matches) return;
    document.querySelectorAll('.main-collection-grid .product-grid').forEach((grid) => {
      const isAllCollection = grid.closest('.collection-wrapper')?.classList.contains('collection-wrapper--all');
      const cardWidth = isAllCollection ? 200 : 200;
      const cardHeight = isAllCollection ? 297 : 312;
      const imageHeight = isAllCollection ? 193 : 198;
      grid.style.setProperty('grid-template-columns', `repeat(5, ${cardWidth}px)`, 'important');
      grid.style.setProperty('justify-content', isAllCollection ? 'center' : 'space-between', 'important');
      grid.style.setProperty('column-gap', isAllCollection ? '24px' : '30px', 'important');
      grid.querySelectorAll('.product-grid__item, .product-card__content').forEach((card) => {
        card.style.setProperty('width', `${cardWidth}px`, 'important');
        card.style.setProperty('height', `${cardHeight}px`, 'important');
        card.style.setProperty('min-height', `${cardHeight}px`, 'important');
      });
      grid.querySelectorAll('.product-grid__item .card-gallery').forEach((gallery) => {
        gallery.style.setProperty('height', `${imageHeight}px`, 'important');
        gallery.style.setProperty('flex-basis', `${imageHeight}px`, 'important');
      });
    });
  };

  compactCollectionCards();
  document.addEventListener('DOMContentLoaded', compactCollectionCards, { once: true });
  new MutationObserver(compactCollectionCards).observe(document.documentElement, { childList: true, subtree: true });

  const initAllCollectionSearch = () => {
    const input = document.querySelector('#CollectionAllSearch');
    const form = input?.closest('form');
    const grid = document.querySelector('.collection-wrapper--all .product-grid');
    const status = document.querySelector('.collection-all-search__status');
    if (!input || !form || !grid || input.dataset.searchInitialized) return;

    input.dataset.searchInitialized = 'true';
    const initialGridMarkup = grid.innerHTML;
    let debounceTimer;
    let activeController;
    let requestId = 0;

    const normalize = (value) =>
      value
        .toLocaleLowerCase('fr-FR')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

    const setStatus = (message) => {
      if (status) status.textContent = message;
    };

    const filterLoadedCards = (query) => {
      const normalizedQuery = normalize(query);
      let matchCount = 0;

      grid.querySelectorAll(':scope > .product-grid__item').forEach((card) => {
        const matches = !normalizedQuery || normalize(card.textContent).includes(normalizedQuery);
        card.hidden = !matches;
        if (matches) matchCount += 1;
      });

      return matchCount;
    };

    const restoreInitialCards = () => {
      requestId += 1;
      activeController?.abort();
      grid.innerHTML = initialGridMarkup;
      compactCollectionCards();
      setStatus('');
    };

    const fetchMatchingCards = async (query) => {
      const currentRequestId = ++requestId;
      activeController?.abort();
      activeController = new AbortController();

      try {
        const response = await fetch(`/search?type=product&q=${encodeURIComponent(query)}`, {
          headers: { Accept: 'text/html' },
          signal: activeController.signal,
        });
        if (!response.ok) throw new Error('Recherche indisponible');

        const html = await response.text();
        if (currentRequestId !== requestId) return;

        const documentFromSearch = new DOMParser().parseFromString(html, 'text/html');
        const matchingCards = Array.from(
          documentFromSearch.querySelectorAll('.product-grid > .product-grid__item')
        );

        if (!matchingCards.length) {
          grid.replaceChildren();
          setStatus('Aucun produit ne correspond à votre recherche.');
          return;
        }

        grid.replaceChildren(...matchingCards.map((card) => document.importNode(card, true)));
        compactCollectionCards();
        setStatus(`${matchingCards.length} produit${matchingCards.length > 1 ? 's' : ''} trouvé${matchingCards.length > 1 ? 's' : ''}`);
      } catch (error) {
        if (error.name === 'AbortError' || currentRequestId !== requestId) return;
        const matchCount = filterLoadedCards(query);
        setStatus(matchCount ? `${matchCount} produit${matchCount > 1 ? 's' : ''} trouvé${matchCount > 1 ? 's' : ''}` : 'Aucun produit ne correspond à votre recherche.');
      }
    };

    const runSearch = () => {
      const query = input.value.trim();
      clearTimeout(debounceTimer);

      if (!query) {
        restoreInitialCards();
        return;
      }

      const matchCount = filterLoadedCards(query);
      setStatus(matchCount ? `${matchCount} résultat${matchCount > 1 ? 's' : ''} dans les produits chargés...` : 'Recherche en cours...');
      debounceTimer = setTimeout(() => fetchMatchingCards(query), 300);
    };

    input.addEventListener('input', runSearch);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      runSearch();
    });
  };

  document.addEventListener('DOMContentLoaded', initAllCollectionSearch, { once: true });

  } catch(e) { console.error(e); }
})();
})();
